<template>
  <div id="app" class="background-1">
    <div class="progress-bar">
      <span
        class="progress-bar--filled"
        :style="{ width: `${$route.meta.progress * 33.33}%` }"
      ></span>
    </div>
    <img
      v-show="!$route.meta.hideSafaltaLogo"
      src="@/assets/images/image-v2/safalta-logo@2x.png"
      alt="safalta-embelem"
      class="safalta-logo"
    />
    <router-view v-slot="{ Component }">
      <transition>
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style>
/* @import url('../../static/fonts/Montserrat/style.css'); */

body {
  font-family: 'Akhand', -apple-system, Montserrat, BlinkMacSystemFont, Segoe UI,
    Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,
    sans-serif !important;
}
#app {
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  font-size: 18px;
  margin-left: auto;
  margin-right: auto;
  min-height: 100vh;
  font-weight: 500;
}

.page-title {
  font-size: 26px;
  font-weight: bold;
  text-align: left;
  color: #015092;
}

.page-wrapper {
  padding: 20px;
}

.img-fluid {
  max-width: 100%;
}

/* */
.background-1 {
  background: #fff url('assets/images/image-v2/bg-2.png') no-repeat center
    center;
  background-size: cover;
}

.safalta-logo {
  width: 50%;
  padding-top: 40px;
  margin-left: auto;
  margin-right: auto;
}

.progress-bar {
  border-radius: 8px;
  padding: 4px;
  background-color: #ffffff;
  display: flex;
  justify-content: flex-start;
  &--filled {
    background-color: #025ddc;
    height: 7px;
    border-radius: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    transition: width 0.45s;
    &:after {
      content: '•';
      font-size: 32px;
      margin-top: 5px;
      color: #fff;
    }
  }
}

/* Generic Typography */
.title {
  font-size: 24px;
  color: #221e46;
}

/* Generic Input Styles */
.error {
  color: red;
  font-size: 12px;
  text-align: left;
}

.btn-yellow,
.btn-turq {
  border-radius: 30px;
  min-width: 180px;
  padding: 12px 36px;
  border: none;
  display: inline-block;
  font-size: 20px;
  margin: 24px auto;
  position: relative;
}

.btn-block {
  width: 100%;
  padding: 16px 36px;
}

.top-spacing {
  margin-top: 48px;
}

.select-input,
.text-input {
  padding: 12px 16px;
  width: 100%;
  font-size: 18px;
  border-radius: 9px;
  border: 2px solid #e4e4e4;
}

.button-white {
  position: relative;
  text-align: center;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  cursor: pointer;
  border-width: 1px;
  border-color: #2499d7;
  border-radius: 5px;
  box-shadow: 3px 3px 0 #2499d7;
  color: white;
  background-color: #fff;
  color: rgb(1, 80, 146);
  font-family: 'Akhand', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}

.button-blue {
  position: relative;
  text-align: center;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  cursor: pointer;
  border-width: 1px;
  border-color: #2499d7;
  border-radius: 5px;
  box-shadow: 3px 3px 0 #2499d7;
  color: white;
  background-color: rgb(1, 80, 146);
  font-family: 'Akhand', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  &--loading {
    pointer-events: none;
    & > span {
      visibility: hidden;
    }
    &:before {
      margin: -13px 0 0 -13px;
      width: 24px;
      height: 24px;
      position: absolute;
      left: 50%;
      top: 50%;
      content: '';
      background-clip: padding-box;
      border-radius: 24px;
      background-clip: padding-box;
      border: rgba(255, 255, 255, 0.25) 2px solid;
      border-top-color: #fff;
      animation: animation-rotate 750ms linear infinite;
    }
  }
}

/* animation */
@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}

.transition {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.4s;
}
.slide-left-enter,
.slide-left-leave-active,
.slide-right-enter,
.slide-right-leave-active {
  opacity: 0;
}
.slide-left-enter,
.slide-right-leave-active {
  transform: translateX(25px);
}
.slide-left-leave-active,
.slide-right-enter {
  transform: translateX(-25px);
}
/* Rotate Animations */
.rotate-enter-active,
.rotate-leave-active {
  transition: all 0.45s;
}
.rotate-enter,
.rotate-leave-active {
  opacity: 0;
}
.rotate-enter {
  transform: rotateY(90deg);
}
.rotate-leave-active {
  transform: rotateY(90deg);
}
.btn-disabled {
  background-color: #cbcbcb;
  color: #2e2e2e;
  cursor: not-allowed;
  pointer-events: none;
  border: none;
  box-shadow: none;
  &:hover {
    background-color: #e4e4e4;
    color: #fff;
    cursor: not-allowed;
    pointer-events: none;
    border: none;
    box-shadow: none;
  }
}
</style>
